<kanzi-ui-main-card
  [title]="'batch_create.title' | translate"
  [description]="'batch_create.description' | translate"
>
  <div class="batch-create-container">
    <!-- Stepper wizard -->
    <p-stepper
      [activeStep]="activeStep()"
      (activeStepChange)="activeStep.set($event)"
      [linear]="true"
    >
      <!-- ========== Paso 1: Selección de Ubicación Padre ========== -->
      <p-stepperPanel [header]="'batch_create.step1.title' | translate">
        <ng-template
          pTemplate="content"
          let-nextCallback="nextCallback"
          let-index="index"
        >
          <div class="step-content">
            <h3 class="step-title">
              {{ 'batch_create.step1.title' | translate }}
            </h3>
            <p class="step-description">
              {{ 'batch_create.step1.description' | translate }}
            </p>

            <!-- Selector de Tipo de Ubicación -->
            <div class="form-field mb-4">
              <label class="required mb-2 block">
                {{ 'batch_create.step1.location_type_label' | translate }}
              </label>
              <p-selectButton
                [options]="locationTypeOptions"
                [ngModel]="locationType()"
                (ngModelChange)="onLocationTypeChange($event)"
                optionLabel="label"
                optionValue="value"
              >
                <ng-template pTemplate="item" let-item>
                  <div class="flex align-items-center gap-2">
                    <i [class]="item.icon"></i>
                    <span>{{ item.label | translate }}</span>
                  </div>
                </ng-template>
              </p-selectButton>
            </div>

            <!-- ===== Flujo Warehouse ===== -->
            @if (locationType() === 'warehouse') {
            <!-- Selector de Bodega -->
            <div class="form-field mb-4">
              <label for="warehouse-select" class="required">
                {{ 'batch_create.step1.warehouse_label' | translate }}
              </label>

              <p-dropdown
                id="warehouse-select"
                [options]="warehouseOptions()"
                [ngModel]="selectedWarehouse()"
                (ngModelChange)="onWarehouseSelected($event)"
                optionLabel="label"
                optionValue="value"
                placeholder="{{ 'batch_create.step1.warehouse_placeholder' | translate }}"
                [showClear]="true"
                [filter]="true"
                filterPlaceholder="{{ 'common.search' | translate }}"
                [loading]="isWarehousesLoading()"
                class="w-full"
                styleClass="w-full"
              ></p-dropdown>
            </div>

            <!-- Selector de Salón (habilitado solo cuando hay bodega seleccionada) -->
            <div class="form-field">
              <label for="salon-select" class="required">
                {{ 'batch_create.step1.salon_label' | translate }}
              </label>

              <p-treeSelect
                id="salon-select"
                [ngModel]="selectedSalon()"
                (ngModelChange)="onSalonSelected($event)"
                [options]="salonTree()"
                placeholder="{{
                  selectedWarehouse()
                    ? ('batch_create.step1.salon_placeholder' | translate)
                    : ('batch_create.step1.salon_select_warehouse_first' | translate)
                }}"
                [showClear]="true"
                [filter]="true"
                filterPlaceholder="{{ 'common.search' | translate }}"
                [loading]="isSalonTreeLoading()"
                [disabled]="!selectedWarehouse()"
                class="w-full"
                (onNodeSelect)="onSalonSelected($event.node)"
              ></p-treeSelect>

              @if (!selectedWarehouse()) {
              <small class="text-gray-500 mt-1 block">
                <i class="pi pi-info-circle mr-1"></i>
                {{ 'batch_create.step1.salon_select_warehouse_first' | translate }}
              </small>
              }
            </div>
            }

            <!-- ===== Flujo Store ===== -->
            @if (locationType() === 'store') {
            <!-- Selector de Tienda -->
            <div class="form-field mb-4">
              <label for="store-select" class="required">
                {{ 'batch_create.step1.store_label' | translate }}
              </label>

              <p-dropdown
                id="store-select"
                [options]="storeOptions()"
                [ngModel]="selectedStore()"
                (ngModelChange)="onStoreSelected($event)"
                optionLabel="label"
                optionValue="value"
                placeholder="{{ 'batch_create.step1.store_placeholder' | translate }}"
                [showClear]="true"
                [filter]="true"
                filterPlaceholder="{{ 'common.search' | translate }}"
                [loading]="isStoresLoading()"
                class="w-full"
                styleClass="w-full"
              ></p-dropdown>
            </div>

            <!-- Selector de Ubicación hija de la tienda -->
            <div class="form-field">
              <label for="store-child-select" class="required">
                {{ 'batch_create.step1.store_child_label' | translate }}
              </label>

              <p-treeSelect
                id="store-child-select"
                [ngModel]="selectedSalon()"
                (ngModelChange)="onSalonSelected($event)"
                [options]="storeChildTree()"
                placeholder="{{
                  selectedStore()
                    ? ('batch_create.step1.store_child_placeholder' | translate)
                    : ('batch_create.step1.store_child_select_store_first' | translate)
                }}"
                [showClear]="true"
                [filter]="true"
                filterPlaceholder="{{ 'common.search' | translate }}"
                [loading]="isStoreChildTreeLoading()"
                [disabled]="!selectedStore()"
                class="w-full"
                (onNodeSelect)="onSalonSelected($event.node)"
              ></p-treeSelect>

              @if (!selectedStore()) {
              <small class="text-gray-500 mt-1 block">
                <i class="pi pi-info-circle mr-1"></i>
                {{ 'batch_create.step1.store_child_select_store_first' | translate }}
              </small>
              }
            </div>
            }

            <!-- Info de ubicación seleccionada (aplica a ambos flujos) -->
            @if (selectedSalonInfo()) {
            <div class="selected-salon-info mt-3">
              <p-card>
                <div class="flex align-items-center gap-2">
                  <i class="pi pi-building text-2xl text-primary"></i>
                  <div class="flex-1">
                    <div class="font-semibold text-lg">
                      {{ selectedSalonInfo()!.name }}
                    </div>
                    @if (selectedSalonInfo()!.displayName) {
                    <div class="text-sm text-gray-600">
                      {{ selectedSalonInfo()!.displayName }}
                    </div>
                    }
                    <div class="flex gap-2 mt-1">
                      <span
                        class="text-xs bg-primary-100 text-primary-700 px-2 py-1 border-round"
                      >
                        {{ selectedSalonInfo()!.type?.name }}
                      </span>
                      @if (selectedSalonInfo()!.externalId) {
                      <span class="text-xs text-gray-500">
                        ID: {{ selectedSalonInfo()!.externalId }}
                      </span>
                      }
                    </div>
                  </div>
                </div>
              </p-card>
            </div>
            }

            <div class="step-actions">
              <p-button
                [label]="'common.next' | translate"
                icon="pi pi-arrow-right"
                iconPos="right"
                [disabled]="!isStep1Valid()"
                (onClick)="nextStep()"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- ========== Paso 2: Selección de Profundidad ========== -->
      <p-stepperPanel [header]="'batch_create.step2.title' | translate">
        <ng-template
          pTemplate="content"
          let-prevCallback="prevCallback"
          let-nextCallback="nextCallback"
        >
          <div class="step-content">
            <h3 class="step-title">
              {{ 'batch_create.step2.title' | translate }}
            </h3>
            <p class="step-description">
              {{ 'batch_create.step2.description' | translate }}
            </p>

            <div class="depth-options">
              @for (depthOption of [1, 2, 3, 4]; track depthOption) {
              <div
                class="depth-card"
                [class.selected]="depth() === depthOption"
              >
                <p-radioButton
                  [name]="'depth'"
                  [value]="depthOption"
                  [ngModel]="depth()"
                  (ngModelChange)="onDepthChange($any($event))"
                  [inputId]="'depth-' + depthOption"
                ></p-radioButton>

                <label [for]="'depth-' + depthOption" class="depth-label">
                  <div class="depth-header">
                    <span class="depth-number"
                      >{{ 'batch_create.step2.depth' | translate }}
                      {{ depthOption }}</span
                    >
                    <i class="pi pi-sitemap"></i>
                  </div>

                  <div class="depth-structure">
                    @switch (depthOption) { @case (1) {
                    <span>SALON → POSITION</span>
                    } @case (2) {
                    <span>SALON → ROW → POSITION</span>
                    } @case (3) {
                    <span>SALON → ROW → RACK → POSITION</span>
                    } @case (4) {
                    <span>SALON → ROW → RACK → LEVEL → POSITION</span>
                    } }
                  </div>

                  <div class="depth-description text-sm text-gray-600 mt-2">
                    {{
                      'batch_create.step2.depth' + depthOption + '_description'
                        | translate
                    }}
                  </div>
                </label>
              </div>
              }
            </div>

            <div class="step-actions">
              <p-button
                [label]="'common.back' | translate"
                icon="pi pi-arrow-left"
                severity="secondary"
                [outlined]="true"
                (onClick)="previousStep()"
              ></p-button>
              <p-button
                [label]="'common.next' | translate"
                icon="pi pi-arrow-right"
                iconPos="right"
                [disabled]="!isStep2Valid()"
                (onClick)="nextStep()"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- ========== Paso 3: Dimensiones y Prefijos ========== -->
      <p-stepperPanel [header]="'batch_create.step3.title' | translate">
        <ng-template
          pTemplate="content"
          let-prevCallback="prevCallback"
          let-nextCallback="nextCallback"
        >
          <div class="step-content">
            <h3 class="step-title">
              {{ 'batch_create.step3.title' | translate }}
            </h3>
            <p class="step-description">
              {{ 'batch_create.step3.description' | translate }}
            </p>

            <div class="configuration-grid">
              <!-- Dimensiones -->
              <div class="config-section">
                <h4 class="section-title">
                  <i class="pi pi-th-large mr-2"></i>
                  {{ 'batch_create.step3.dimensions_title' | translate }}
                </h4>

                <div class="form-grid">
                  @if (depth() && depth()! >= 2) {
                  <div class="form-field">
                    <label for="rows">
                      {{ 'batch_create.step3.rows' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.rows_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <p-inputNumber
                      id="rows"
                      [ngModel]="dimensions().rows"
                      [min]="1"
                      [max]="100"
                      [showButtons]="true"
                      buttonLayout="horizontal"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                      (ngModelChange)="onDimensionChange('rows', $event)"
                    ></p-inputNumber>
                  </div>
                  } @if (depth() && depth()! >= 3) {
                  <div class="form-field">
                    <label for="racks">
                      {{ 'batch_create.step3.racks' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.racks_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <p-inputNumber
                      id="racks"
                      [ngModel]="dimensions().racks"
                      [min]="1"
                      [max]="100"
                      [showButtons]="true"
                      buttonLayout="horizontal"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                      (ngModelChange)="onDimensionChange('racks', $event)"
                    ></p-inputNumber>
                  </div>
                  } @if (depth() === 4) {
                  <div class="form-field">
                    <label for="levels">
                      {{ 'batch_create.step3.levels' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.levels_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <p-inputNumber
                      id="levels"
                      [ngModel]="dimensions().levels"
                      [min]="1"
                      [max]="100"
                      [showButtons]="true"
                      buttonLayout="horizontal"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                      (ngModelChange)="onDimensionChange('levels', $event)"
                    ></p-inputNumber>
                  </div>
                  }

                  <div class="form-field">
                    <label for="positions">
                      {{ 'batch_create.step3.positions' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.positions_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <p-inputNumber
                      id="positions"
                      [ngModel]="dimensions().positions"
                      [min]="1"
                      [max]="100"
                      [showButtons]="true"
                      buttonLayout="horizontal"
                      incrementButtonIcon="pi pi-plus"
                      decrementButtonIcon="pi pi-minus"
                      (ngModelChange)="onDimensionChange('positions', $event)"
                    ></p-inputNumber>
                  </div>
                </div>
              </div>

              <!-- Prefijos Personalizables -->
              <div class="config-section">
                <h4 class="section-title">
                  <i class="pi pi-tag mr-2"></i>
                  {{ 'batch_create.step3.prefixes_title' | translate }}
                </h4>

                @if (prefixErrorMessage()) {
                <p-message
                  severity="error"
                  [text]="prefixErrorMessage()!"
                  class="mb-3"
                ></p-message>
                }

                <div class="form-grid">
                  @if (depth() && depth()! >= 2) {
                  <div class="form-field">
                    <label for="prefix-row">
                      {{ 'batch_create.step3.prefix_row' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.prefix_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <input
                      pInputText
                      id="prefix-row"
                      [ngModel]="prefixes().row"
                      maxlength="10"
                      placeholder="F"
                      (ngModelChange)="onPrefixChange('row', $event)"
                    />
                  </div>
                  } @if (depth() && depth()! >= 3) {
                  <div class="form-field">
                    <label for="prefix-rack">
                      {{ 'batch_create.step3.prefix_rack' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.prefix_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <input
                      pInputText
                      id="prefix-rack"
                      [ngModel]="prefixes().rack"
                      maxlength="10"
                      placeholder="R"
                      (ngModelChange)="onPrefixChange('rack', $event)"
                    />
                  </div>
                  } @if (depth() === 4) {
                  <div class="form-field">
                    <label for="prefix-level">
                      {{ 'batch_create.step3.prefix_level' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.prefix_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <input
                      pInputText
                      id="prefix-level"
                      [ngModel]="prefixes().level"
                      maxlength="10"
                      placeholder="L"
                      (ngModelChange)="onPrefixChange('level', $event)"
                    />
                  </div>
                  }

                  <div class="form-field">
                    <label for="prefix-position">
                      {{ 'batch_create.step3.prefix_position' | translate }}
                      <i
                        class="pi pi-info-circle ml-1"
                        pTooltip="{{
                          'batch_create.step3.prefix_tooltip' | translate
                        }}"
                        tooltipPosition="top"
                      ></i>
                    </label>
                    <input
                      pInputText
                      id="prefix-position"
                      [ngModel]="prefixes().position"
                      maxlength="10"
                      placeholder="P"
                      (ngModelChange)="onPrefixChange('position', $event)"
                    />
                  </div>
                </div>
              </div>

              <!-- Formato de Consecutivo -->
              <div class="config-section full-width">
                <h4 class="section-title">
                  <i class="pi pi-sort-numeric-up mr-2"></i>
                  {{
                    'batch_create.step3.consecutive_format_title' | translate
                  }}
                </h4>

                <div class="consecutive-format-options">
                  <div class="format-option">
                    <p-radioButton
                      name="consecutiveFormat"
                      value="numeric"
                      [ngModel]="consecutiveFormat()"
                      inputId="format-numeric"
                      (ngModelChange)="onConsecutiveFormatChange($any($event))"
                    ></p-radioButton>
                    <label for="format-numeric" class="ml-2">
                      <strong>{{
                        'batch_create.step3.format_numeric' | translate
                      }}</strong>
                      <span class="text-sm text-gray-600 ml-2"
                        >(1, 2, 3, ..., 10)</span
                      >
                    </label>
                  </div>

                  <div class="format-option">
                    <p-radioButton
                      name="consecutiveFormat"
                      value="padded"
                      [ngModel]="consecutiveFormat()"
                      inputId="format-padded"
                      (ngModelChange)="onConsecutiveFormatChange($any($event))"
                    ></p-radioButton>
                    <label for="format-padded" class="ml-2">
                      <strong>{{
                        'batch_create.step3.format_padded' | translate
                      }}</strong>
                      <span class="text-sm text-gray-600 ml-2"
                        >(01, 02, 03, ..., 10)</span
                      >
                    </label>
                  </div>

                  @if (consecutiveFormat() === 'padded') {
                  <div class="form-field mt-3">
                    <label for="padding-digits">
                      {{ 'batch_create.step3.padding_digits' | translate }}
                    </label>
                    <p-inputNumber
                      id="padding-digits"
                      [ngModel]="paddingDigits()"
                      [min]="2"
                      [max]="5"
                      [showButtons]="true"
                      (ngModelChange)="onPaddingDigitsChange($event)"
                    ></p-inputNumber>
                  </div>
                  }
                </div>
              </div>

              <!-- Preview de Nomenclatura -->
              <div class="config-section full-width">
                <p-card>
                  <div class="nomenclature-preview">
                    <h5>
                      <i class="pi pi-eye mr-2"></i>
                      {{
                        'batch_create.step3.nomenclature_preview' | translate
                      }}
                    </h5>
                    <div class="preview-example">
                      <code>{{ nomenclatureExample() }}</code>
                    </div>
                    <div class="preview-stats mt-2">
                      <small class="text-gray-600">
                        {{ 'batch_create.step3.max_length' | translate }}:
                        {{ maxNomenclatureLength() }}
                        {{ 'batch_create.step3.characters' | translate }}
                      </small>
                    </div>
                  </div>
                </p-card>
              </div>

              <!-- Resumen de Total -->
              <div class="config-section full-width">
                <p-card
                  [styleClass]="
                    isVeryLargeBatchComputed() ? 'warning-card' : 'info-card'
                  "
                >
                  <div class="total-summary">
                    <div class="total-number">
                      <i class="pi pi-list text-4xl"></i>
                      <div class="ml-3">
                        <div class="text-sm text-gray-600">
                          {{ 'batch_create.step3.total_locations' | translate }}
                        </div>
                        <div class="text-3xl font-bold">
                          {{ totalLocations() }}
                        </div>
                        <div class="text-sm text-gray-600">
                          {{ 'batch_create.step3.estimated_time' | translate }}:
                          {{ estimatedTime() }}
                        </div>
                      </div>
                    </div>

                    @if (batchSizeWarning()) {
                    <p-message
                      severity="warn"
                      [text]="batchSizeWarning()!"
                      class="mt-3"
                    ></p-message>
                    }
                  </div>
                </p-card>
              </div>
            </div>

            <div class="step-actions">
              <p-button
                [label]="'common.back' | translate"
                icon="pi pi-arrow-left"
                severity="secondary"
                [outlined]="true"
                (onClick)="previousStep()"
              ></p-button>
              <p-button
                [label]="'batch_create.generate_preview' | translate"
                icon="pi pi-eye"
                iconPos="right"
                [disabled]="!isStep3Valid()"
                [loading]="isGenerating()"
                (onClick)="nextStep()"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- ========== Paso 4: Preview ========== -->
      <p-stepperPanel [header]="'batch_create.step4.title' | translate">
        <ng-template
          pTemplate="content"
          let-prevCallback="prevCallback"
          let-nextCallback="nextCallback"
        >
          <div class="step-content">
            <h3 class="step-title">
              {{ 'batch_create.step4.title' | translate }}
            </h3>
            <p class="step-description">
              {{ 'batch_create.step4.description' | translate }}
            </p>

            @if (isGenerating()) {
            <div class="text-center p-5">
              <i class="pi pi-spin pi-spinner text-4xl text-primary mb-3"></i>
              <p>{{ 'batch_create.step4.generating' | translate }}</p>
            </div>
            } @else if (previewStats()) {
            <!-- Estadísticas Generales -->
            <div class="preview-stats mb-4">
              <div class="grid">
                <!-- Total de Ubicaciones -->
                <div class="col-12 md:col-6 lg:col-3">
                  <p-card>
                    <div class="stat-card">
                      <i class="pi pi-th-large text-3xl text-primary mb-2"></i>
                      <div class="stat-value">{{ previewStats()!.total }}</div>
                      <div class="stat-label">
                        {{ 'batch_create.step4.total_locations' | translate }}
                      </div>
                    </div>
                  </p-card>
                </div>

                <!-- Desglose por Tipo -->
                <div class="col-12 md:col-6 lg:col-9">
                  <p-card>
                    <div class="type-breakdown">
                      <h4 class="mb-3">
                        {{ 'batch_create.step4.breakdown_by_type' | translate }}
                      </h4>
                      <div class="flex flex-wrap gap-3">
                        <div class="type-badge">
                          <i class="pi pi-bars mr-2"></i>
                          <span class="font-semibold">ROWS:</span>
                          <span class="ml-1">{{
                            previewStats()!.byType.rows
                          }}</span>
                        </div>
                        <div class="type-badge">
                          <i class="pi pi-th-large mr-2"></i>
                          <span class="font-semibold">RACKS:</span>
                          <span class="ml-1">{{
                            previewStats()!.byType.racks
                          }}</span>
                        </div>
                        <div class="type-badge">
                          <i class="pi pi-align-justify mr-2"></i>
                          <span class="font-semibold">LEVELS:</span>
                          <span class="ml-1">{{
                            previewStats()!.byType.levels
                          }}</span>
                        </div>
                        <div class="type-badge">
                          <i class="pi pi-box mr-2"></i>
                          <span class="font-semibold">POSITIONS:</span>
                          <span class="ml-1">{{
                            previewStats()!.byType.positions
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </p-card>
                </div>
              </div>
            </div>

            <!-- Ejemplos de Nomenclatura -->
            <div class="nomenclature-examples mb-4">
              <p-card>
                <h4 class="mb-3">
                  <i class="pi pi-tag mr-2"></i>
                  {{ 'batch_create.step4.nomenclature_examples' | translate }}
                </h4>
                <div class="grid">
                  <div class="col-12 md:col-4">
                    <div class="example-item">
                      <label class="text-sm text-gray-600">{{
                        'batch_create.step4.first_location' | translate
                      }}</label>
                      <div class="font-mono font-semibold text-primary">
                        {{ previewStats()!.firstLocation }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4">
                    <div class="example-item">
                      <label class="text-sm text-gray-600">{{
                        'batch_create.step4.last_location' | translate
                      }}</label>
                      <div class="font-mono font-semibold text-primary">
                        {{ previewStats()!.lastLocation }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 md:col-4">
                    <div class="example-item">
                      <label class="text-sm text-gray-600">{{
                        'batch_create.step4.sample_count' | translate
                      }}</label>
                      <div class="font-semibold">
                        {{ previewStats()!.preview.sample.positions.length }}
                        {{ 'batch_create.step4.samples' | translate }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Muestras de Nomenclatura -->
                @if (previewStats()!.preview.sample.positions.length > 0) {
                <p-divider></p-divider>
                <div class="sample-list">
                  <label class="text-sm text-gray-600 mb-2 block"
                    >{{
                      'batch_create.step4.sample_nomenclatures' | translate
                    }}:</label
                  >
                  <div class="flex flex-wrap gap-2">
                    @for (sample of previewStats()!.preview.sample.positions;
                    track sample) {
                    <p-tag [value]="sample" icon="pi pi-box"></p-tag>
                    }
                  </div>
                </div>
                }
              </p-card>
            </div>

            <!-- Árbol de Preview -->
            <div class="preview-tree">
              <p-card>
                <div
                  class="flex justify-content-between align-items-center mb-3"
                >
                  <h4>
                    <i class="pi pi-sitemap mr-2"></i>
                    {{ 'batch_create.step4.location_hierarchy' | translate }}
                  </h4>
                  <div class="flex gap-2">
                    <p-button
                      icon="pi pi-angle-down"
                      severity="secondary"
                      [outlined]="true"
                      size="small"
                      pTooltip="Expandir todo"
                      tooltipPosition="top"
                      (onClick)="expandAll()"
                    ></p-button>
                    <p-button
                      icon="pi pi-angle-up"
                      severity="secondary"
                      [outlined]="true"
                      size="small"
                      pTooltip="Colapsar todo"
                      tooltipPosition="top"
                      (onClick)="collapseAll()"
                    ></p-button>
                    <p-button
                      [label]="'batch_create.step4.edit_config' | translate"
                      icon="pi pi-pencil"
                      severity="secondary"
                      [outlined]="true"
                      size="small"
                      (onClick)="goToStep(2)"
                    ></p-button>
                  </div>
                </div>

                @if (previewTree().length > 0) {
                <div class="tree-scroll-container">
                  <p-tree
                    #treeComponent
                    [value]="previewTree()"
                    styleClass="w-full"
                    [propagateSelectionDown]="false"
                    [propagateSelectionUp]="false"
                  >
                    <ng-template pTemplate="default" let-node>
                      <div class="flex align-items-center gap-2">
                        <i [class]="node.icon" class="text-primary"></i>
                        <span class="font-mono">{{ node.label }}</span>
                        <p-tag
                          [value]="node.type"
                          [severity]="getTagSeverity(node.type)"
                          size="small"
                        ></p-tag>
                      </div>
                    </ng-template>
                  </p-tree>
                </div>
                } @else {
                <p-message
                  severity="info"
                  text="{{ 'batch_create.step4.no_locations' | translate }}"
                ></p-message>
                }
              </p-card>
            </div>
            } @else {
            <p-message
              severity="warn"
              text="{{ 'batch_create.step4.generate_first' | translate }}"
            ></p-message>
            }

            <div class="step-actions">
              <p-button
                [label]="'common.back' | translate"
                icon="pi pi-arrow-left"
                severity="secondary"
                [outlined]="true"
                (onClick)="previousStep()"
              ></p-button>
              <p-button
                [label]="'common.next' | translate"
                icon="pi pi-arrow-right"
                iconPos="right"
                [disabled]="!isStep4Valid()"
                (onClick)="nextStep()"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- ========== Paso 5: Confirmación ========== -->
      <p-stepperPanel [header]="'batch_create.step5.title' | translate">
        <ng-template pTemplate="content" let-prevCallback="prevCallback">
          <div class="step-content">
            <h3 class="step-title">
              {{ 'batch_create.step5.title' | translate }}
            </h3>
            <p class="step-description">
              {{ 'batch_create.step5.description' | translate }}
            </p>

            <!-- Resumen final mejorado -->
            <div class="confirmation-summary mb-4">
              <p-card>
                <h4 class="mb-3">
                  <i class="pi pi-info-circle mr-2"></i>
                  {{ 'batch_create.step5.summary_title' | translate }}
                </h4>

                <div class="grid">
                  <!-- Origen (Bodega o Tienda) -->
                  <div class="col-12 md:col-6">
                    <div class="summary-item">
                      <label>{{
                        locationType() === 'warehouse'
                          ? ('batch_create.step5.warehouse' | translate)
                          : ('batch_create.step5.store' | translate)
                      }}</label>
                      <div class="flex align-items-center gap-2 mt-2">
                        <i [class]="locationType() === 'warehouse' ? 'pi pi-warehouse text-primary' : 'pi pi-shop text-primary'"></i>
                        <span class="font-semibold">{{
                          locationType() === 'warehouse'
                            ? selectedWarehouse()?.name
                            : selectedStore()?.name
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Ubicación Padre -->
                  <div class="col-12 md:col-6">
                    <div class="summary-item">
                      <label>{{
                        locationType() === 'warehouse'
                          ? ('batch_create.step5.salon' | translate)
                          : ('batch_create.step5.parent_location' | translate)
                      }}</label>
                      <div class="flex align-items-center gap-2 mt-2">
                        <i class="pi pi-building text-primary"></i>
                        <span class="font-semibold">{{
                          selectedSalonInfo()?.name
                        }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Profundidad -->
                  <div class="col-12 md:col-6">
                    <div class="summary-item">
                      <label>{{
                        'batch_create.step5.depth' | translate
                      }}</label>
                      <div class="mt-2">
                        <p-tag
                          [value]="'Nivel ' + depth()"
                          severity="info"
                        ></p-tag>
                      </div>
                    </div>
                  </div>

                  <!-- Total de Ubicaciones -->
                  <div class="col-12 md:col-6">
                    <div class="summary-item">
                      <label>{{
                        'batch_create.step5.total' | translate
                      }}</label>
                      <div class="font-bold text-3xl text-primary mt-2">
                        {{ totalLocations() }}
                      </div>
                    </div>
                  </div>

                  <!-- Tiempo Estimado -->
                  <div class="col-12 md:col-6">
                    <div class="summary-item">
                      <label>{{ 'batch_create.step5.time' | translate }}</label>
                      <div class="flex align-items-center gap-2 mt-2">
                        <i class="pi pi-clock"></i>
                        <span class="font-semibold">{{ estimatedTime() }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- Configuración de Prefijos -->
                  <div class="col-12">
                    <p-divider></p-divider>
                    <div class="summary-item">
                      <label>{{
                        'batch_create.step5.prefix_config' | translate
                      }}</label>
                      <div class="flex flex-wrap gap-2 mt-2">
                        @if (depth() && depth()! >= 2) {
                        <p-tag
                          value="ROW: {{ prefixes().row }}"
                          severity="success"
                        ></p-tag>
                        } @if (depth() && depth()! >= 3) {
                        <p-tag
                          value="RACK: {{ prefixes().rack }}"
                          severity="warning"
                        ></p-tag>
                        } @if (depth() === 4) {
                        <p-tag
                          value="LEVEL: {{ prefixes().level }}"
                          severity="secondary"
                        ></p-tag>
                        }
                        <p-tag
                          value="POSITION: {{ prefixes().position }}"
                          severity="contrast"
                        ></p-tag>
                      </div>
                    </div>
                  </div>

                  <!-- Formato de Consecutivo -->
                  <div class="col-12">
                    <div class="summary-item">
                      <label>{{
                        'batch_create.step5.consecutive_format' | translate
                      }}</label>
                      <div class="mt-2">
                        @if (consecutiveFormat() === 'numeric') {
                        <span>{{
                          'batch_create.step5.format_numeric' | translate
                        }}</span>
                        } @else {
                        <span
                          >{{
                            'batch_create.step5.format_padded' | translate
                          }}
                          ({{ paddingDigits() }}
                          {{ 'batch_create.step5.digits' | translate }})</span
                        >
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </p-card>
            </div>

            <!-- Checkbox de Confirmación -->
            <div class="confirmation-checkbox mb-4">
              <p-card>
                <div class="flex align-items-center gap-3">
                  <p-checkbox
                    [ngModel]="confirmCreation()"
                    (ngModelChange)="confirmCreation.set($event)"
                    [binary]="true"
                    inputId="confirm-creation"
                  ></p-checkbox>
                  <label
                    for="confirm-creation"
                    class="font-semibold cursor-pointer"
                  >
                    {{ 'batch_create.step5.confirm_message' | translate }}
                  </label>
                </div>
                <p-divider></p-divider>
                <p class="text-sm text-gray-600 mb-0">
                  <i class="pi pi-info-circle mr-2"></i>
                  {{ 'batch_create.step5.warning_message' | translate }}
                </p>
              </p-card>
            </div>

            @if (validationErrors().length > 0) {
            <div class="error-messages mb-4">
              @for (error of validationErrors(); track error) {
              <p-message
                severity="error"
                [text]="error"
                class="mb-2"
              ></p-message>
              }
            </div>
            }

            <div class="step-actions">
              <p-button
                [label]="'common.back' | translate"
                icon="pi pi-arrow-left"
                severity="secondary"
                [outlined]="true"
                [disabled]="isCreating()"
                (onClick)="previousStep()"
              ></p-button>
              <p-button
                [label]="'batch_create.create_locations' | translate"
                icon="pi pi-save"
                iconPos="right"
                severity="primary"
                [loading]="isCreating()"
                [disabled]="!canCreate()"
                (onClick)="createLocations()"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- ========== Paso 6: Resultado Exitoso ========== -->
      <p-stepperPanel [header]="'batch_create.success.title' | translate">
        <ng-template pTemplate="content">
          <div class="step-content result-screen success-screen">
            <div class="result-header">
              <i class="pi pi-check-circle success-icon"></i>
              <h2 class="result-title">
                {{ 'batch_create.success.title' | translate }}
              </h2>
              <p class="result-subtitle">
                {{ 'batch_create.success.subtitle' | translate }}
              </p>
            </div>

            @if (creationResult()) {
            <div class="result-stats">
              <!-- Total Created Card -->
              <div class="stat-card primary">
                <div class="stat-icon">
                  <i class="pi pi-check-circle"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-label">
                    {{ 'batch_create.success.total_created' | translate }}
                  </div>
                  <div class="stat-value">
                    {{ creationResult()!.statistics.total_created }}
                  </div>
                </div>
              </div>

              <!-- Execution Time Card -->
              <div class="stat-card info">
                <div class="stat-icon">
                  <i class="pi pi-clock"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-label">
                    {{ 'batch_create.success.execution_time' | translate }}
                  </div>
                  <div class="stat-value">
                    {{ (creationResult()!.duration_seconds ?? 0).toFixed(2) }}s
                  </div>
                </div>
              </div>

              <!-- Success Rate Card -->
              <div class="stat-card success">
                <div class="stat-icon">
                  <i class="pi pi-percentage"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-label">
                    {{ 'batch_create.success.success_rate' | translate }}
                  </div>
                  <div class="stat-value">
                    {{ (creationResult()!.statistics.success_rate).toFixed(0) }}%
                  </div>
                </div>
              </div>
            </div>

            <!-- Breakdown Accordion -->
            <p-accordion [multiple]="false" class="result-accordion">
              @if (creationResult()!.statistics.by_type) {
              <p-accordionTab
                [header]="'batch_create.success.breakdown_title' | translate"
              >
                <div class="breakdown-content">
                  <div class="breakdown-list">
                    @if (creationResult()!.statistics.by_type!.rows_created) {
                    <div class="breakdown-item">
                      <span class="breakdown-label">
                        <i class="pi pi-tag mr-2"></i>
                        Filas
                      </span>
                      <span class="breakdown-value">
                        <p-tag
                          [value]="
                            '' + creationResult()!.statistics.by_type!.rows_created
                          "
                          severity="success"
                        ></p-tag>
                      </span>
                    </div>
                    } @if (creationResult()!.statistics.by_type!.racks_created)
                    {
                    <div class="breakdown-item">
                      <span class="breakdown-label">
                        <i class="pi pi-tag mr-2"></i>
                        Racks
                      </span>
                      <span class="breakdown-value">
                        <p-tag
                          [value]="
                            '' + creationResult()!.statistics.by_type!.racks_created
                          "
                          severity="success"
                        ></p-tag>
                      </span>
                    </div>
                    } @if (creationResult()!.statistics.by_type!.levels_created)
                    {
                    <div class="breakdown-item">
                      <span class="breakdown-label">
                        <i class="pi pi-tag mr-2"></i>
                        Niveles
                      </span>
                      <span class="breakdown-value">
                        <p-tag
                          [value]="
                            '' + creationResult()!.statistics.by_type!.levels_created
                          "
                          severity="success"
                        ></p-tag>
                      </span>
                    </div>
                    } @if
                    (creationResult()!.statistics.by_type!.positions_created) {
                    <div class="breakdown-item">
                      <span class="breakdown-label">
                        <i class="pi pi-tag mr-2"></i>
                        Posiciones
                      </span>
                      <span class="breakdown-value">
                        <p-tag
                          [value]="
                            '' + creationResult()!.statistics.by_type!.positions_created
                          "
                          severity="success"
                        ></p-tag>
                      </span>
                    </div>
                    }
                  </div>
                </div>
              </p-accordionTab>
              } @if (creationResult()!.created_location_ids &&
              creationResult()!.created_location_ids!.length > 0) {
              <p-accordionTab header="IDs Creados (Primeros 10)">
                <div class="sample-codes">
                  <div class="codes-grid">
                    @for (id of creationResult()!.created_location_ids!.slice(0,
                    10); track id) {
                    <p-tag [value]="id.toString()" [rounded]="true"></p-tag>
                    }
                  </div>
                </div>
              </p-accordionTab>
              }
            </p-accordion>
            }

            <!-- Action Buttons -->
            <div class="result-actions">
              <p-button
                [label]="'batch_create.success.view_locations' | translate"
                icon="pi pi-list"
                severity="primary"
                (onClick)="navigateToLocations()"
              ></p-button>
              <p-button
                [label]="'batch_create.success.view_parent' | translate"
                icon="pi pi-building"
                severity="info"
                [outlined]="true"
                (onClick)="navigateToParentSalon()"
              ></p-button>
              <p-button
                [label]="'batch_create.success.create_another' | translate"
                icon="pi pi-plus"
                severity="secondary"
                [outlined]="true"
                (onClick)="resetWizard()"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>

      <!-- ========== Paso 7: Error ========== -->
      <p-stepperPanel [header]="'batch_create.error.title' | translate">
        <ng-template pTemplate="content">
          <div class="step-content result-screen error-screen">
            <div class="result-header">
              <i class="pi pi-times-circle error-icon"></i>
              <h2 class="result-title">
                {{ 'batch_create.error.title' | translate }}
              </h2>
              <p class="result-subtitle">
                {{
                  errorMessage() || ('batch_create.error.subtitle' | translate)
                }}
              </p>
            </div>

            @if (errorDetails().length > 0) {
            <p-accordion [multiple]="false" class="error-accordion">
              <p-accordionTab
                [header]="'batch_create.error.details_title' | translate"
              >
                <div class="error-details">
                  <ul class="error-list">
                    @for (detail of errorDetails(); track $index) {
                    <li class="error-item">
                      <i class="pi pi-exclamation-triangle mr-2"></i>
                      {{ detail }}
                    </li>
                    }
                  </ul>
                </div>
              </p-accordionTab>
            </p-accordion>
            }

            <!-- Error Summary Card -->
            <p-card class="error-summary-card">
              <div class="error-summary">
                <div class="error-summary-item">
                  <span class="label">{{
                    'batch_create.error.attempted' | translate
                  }}</span>
                  <span class="value">{{
                    generatedResult()?.statistics?.total || 0
                  }}</span>
                </div>
                <div class="error-summary-item">
                  <span class="label">{{
                    'batch_create.error.failed' | translate
                  }}</span>
                  <span class="value error-value">{{
                    generatedResult()?.statistics?.total || 0
                  }}</span>
                </div>
              </div>
            </p-card>

            <!-- Action Buttons -->
            <div class="result-actions">
              <p-button
                [label]="'batch_create.error.retry' | translate"
                icon="pi pi-refresh"
                severity="warning"
                (onClick)="retryCreation()"
              ></p-button>
              <p-button
                [label]="'batch_create.error.start_over' | translate"
                icon="pi pi-replay"
                severity="secondary"
                [outlined]="true"
                (onClick)="resetWizard()"
              ></p-button>
              <p-button
                [label]="'batch_create.error.view_list' | translate"
                icon="pi pi-list"
                severity="primary"
                [outlined]="true"
                (onClick)="cancel()"
              ></p-button>
            </div>
          </div>
        </ng-template>
      </p-stepperPanel>
    </p-stepper>
  </div>
</kanzi-ui-main-card>
